import { useState } from 'react';
import type { Pagination, WithOptional } from '@flemingmetrics/api-client';

type PartialPagination = WithOptional<Pagination, 'pageCount' | 'rowCount'>;

export function usePagination(page = 1, pageSize = 20) {
  const [pagination, setPagination] = useState<PartialPagination>({
    page,
    pageSize,
  });

  const setPage = (newPage: number) => {
    setPagination((p) => ({ ...p, page: newPage }));
  };

  const setPageSize = (newPageSize: number) => {
    setPagination((p) => ({ ...p, pageSize: newPageSize }));
  };

  return [pagination, setPagination, { setPage, setPageSize }] as const;
}
